package com.macrofocus.eflux.animation

import kotlin.math.log2
import kotlin.math.pow

class ZoomEasing : Easing {
    override fun ease(t: Double, b: Double, c: Double, d: Double): Double {
        // Normalize time to [0,1]
        val normalizedT = (t / d).coerceIn(0.0, 1.0)

        // Use easeInOutQuad for smoothing
        val easedT = if (normalizedT < 0.5) {
            2 * normalizedT * normalizedT
        } else {
            -1 + (4 - 2 * normalizedT) * normalizedT
        }

        // Convert zoom levels to scale (2^zoom), interpolate scale linearly
        val scaleStart = 2.0.pow(b)
        val scaleEnd = 2.0.pow(b + c)
        val scaleCurrent = scaleStart + (scaleEnd - scaleStart) * easedT

        // Convert back to zoom
        return log2(scaleCurrent)
    }

}